import { c as _c } from "react/compiler-runtime";
import type { TextSizes } from '@newfront-insurance/core-ui';
import { Text } from '@newfront-insurance/core-ui';
import type { JSX } from 'react';
interface Props {
  name?: string;
  label: string;
  size?: TextSizes;
  color?: string;
}

/**
 * Renders label text given a label
 * @param props
 */
export function Label(t0) {
  const $ = _c(5);
  const {
    name,
    label,
    size: t1,
    color: t2
  } = t0;
  const size = t1 === undefined ? "small" : t1;
  const color = t2 === undefined ? "light" : t2;
  const t3 = `Label-${name}`;
  let t4;
  if ($[0] !== color || $[1] !== label || $[2] !== size || $[3] !== t3) {
    t4 = <Text size={size} color={color} testId={t3}>{label}</Text>;
    $[0] = color;
    $[1] = label;
    $[2] = size;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}